<div class="layout-container" [ngClass]="containerClass">
    <app-sidebar></app-sidebar>
    <div class="layout-content-wrapper">
        <!-- Sticky header wrapper -->
        <div class="sticky-header-wrapper">
            <ng-container *ngIf="showProgress">
                <p-progressBar mode="indeterminate" class="fixed w-full"  [style]="{ height: '2px' }" />
            </ng-container>
            <app-topbar></app-topbar>
            <app-breadcrumb class="content-breadcrumb"></app-breadcrumb>
            <cwa-applied-filter-bar class="applied-filter-bar"></cwa-applied-filter-bar>
        </div>
        
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-profilemenu></app-profilemenu>
    <!-- <app-config></app-config> -->
    <div class="layout-mask"></div>
</div>

<p-toast position="top-right" key="toast" />
<!-- <cwa-global-filter /> -->
